import {
  getFailActionName,
  getStartActionName,
  getSuccessActionName,
} from "../../../core/make-action";
import ViewerMethod from "../../../core/ViewerMethod";
import { DetailedLoadStatus } from "../../../../../../../common/utils/async-status";

interface PrintJob {
  from: string;
  to: string;
  internalUUID: string;
  status: DetailedLoadStatus;
  frameUUID: string;
}

function updateItem(state, action, status: DetailedLoadStatus, data = {}) {
  const index = state.findIndex((el) => el.internalUUID === action.uuid);
  const clone = [...state];
  clone[index] = { ...clone[index], ...data, status };
  return clone;
}

export default function (state: PrintJob[] = [], action) {
  switch (action.type) {
    case getStartActionName(ViewerMethod.PRINT):
      return [
        {
          ...action.apiCallArgs[0],
          internalUUID: action.uuid,
          status: DetailedLoadStatus.FETCHING,
        },
      ];
    case getSuccessActionName(ViewerMethod.PRINT):
      return updateItem(state, action, DetailedLoadStatus.OK, {
        ...action.resultData,
      });
    case getFailActionName(ViewerMethod.PRINT):
      return updateItem(state, action, DetailedLoadStatus.ERROR);
    default:
      return state;
  }
}
